import request from "../Utils/Request";

export function postData(url: string, data: any) {
  return request.post(url, data);
}
